import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GradeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"grade"}/>
}
